import React from 'react';
import { Link } from 'gatsby';
import Title from '../../components/Title';
import styled from 'styled-components';
import BookCover from '../../components/BookCover';
import Text from '../../components/Text';


function BookSummery({ className }) {
  return (
    <section className={className}>
      <BookCover className='cover' />
      <div className='textContainer'>
        <Title lite>
          <h1>Three Invaders</h1>
        </Title>
        <Text lite>
          Politicians for decades have debated and posed solutions for the
          troubled region we know as the “Middle East” to no avail. As a
          neurosurgeon, Saleem Abdulrauf has treated hundreds of patients with
          complex brain tumors and aneurysms. This involves review of published
          data, critical analysis of available treatment options, analysis of
          complex problems, and thinking outside the box. In some cases,
          Professor Abdulrauf has even had to develop new surgical techniques to
          cure his patients. Throughout this process he has learned to
          systematically and scientifically break down a problem to come up with
          effective solutions. In Three Invaders, Professor Abdulrauf employs
          the same strategy to evaluate long-standing conflicts and present
          novel solutions. In breaking down these conflicts, he shares with the
          reader omitted historical facts and provides insights into previously
          undisclosed geopolitics of popular culture - in particular the
          2,000-year cultural, military, and political history of the
          interaction among the peoples of the three Abrahamic religions
          (Judaism, Christianity, and Islam), with a special focus on the past
          100 years.
        </Text>
        <Link to="/book">Learn More</Link>
      </div>
    </section>
  );
}

export default styled(BookSummery)`
  display: flex;

  justify-content: space-around;
  align-items: center;
  padding-bottom: 60px;
  background: #0c0c0c;
  background-image: url(data:image/png;base64,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);
  width: 100%;
  .cover {
    width: 40%;
  }
  .textContainer {
    width: 50%;
    margin: auto 20px;
    padding: 20px 0;
    border-bottom: 1px solid #636365;
  }

  a, a:visited{
    color: var(--tertiaryColor);
  }
    a:hover{
    color: var(--offWhite);
  }

  @media (max-width: 450px) {
    display: flow-root;
    padding: 40px 20px;
    .cover {
      margin-top: 50px;
      width: 100%;
    }
    .textContainer {
      width: 100%;
      margin: 40px 0 0;
      padding: 20px 0;
    }
  }
`;
